export default "__VITE_ASSET__a0eac531__$_?component__"